export type Orientation = "landscape" | "portrait";
export type Brightness = "light" | "dark";

export function loadImageElement(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error(`Bild "${file.name}" konnte nicht geladen werden`));
    };
    img.src = url;
  });
}

export function analyzeImageProperties(img: HTMLImageElement): { orientation: Orientation; brightness: Brightness } {
  const orientation: Orientation = img.naturalWidth >= img.naturalHeight ? "landscape" : "portrait";

  const sampleSize = 50;
  const canvas = document.createElement("canvas");
  canvas.width = sampleSize;
  canvas.height = sampleSize;
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    return { orientation, brightness: "light" };
  }

  ctx.drawImage(img, 0, 0, sampleSize, sampleSize);
  const { data } = ctx.getImageData(0, 0, sampleSize, sampleSize);

  let totalLuminance = 0;
  const pixelCount = data.length / 4;
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    totalLuminance += 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }
  const avgLuminance = totalLuminance / pixelCount;
  const brightness: Brightness = avgLuminance > 127 ? "dark" : "light";

  return { orientation, brightness };
}